<template>
    <div class="loader"
        :class="isStatic ? 'is-static': ''"
    >
        <div class="loader__item"></div>
    </div>
</template>

<script>
    export default {
        props: {
            isStatic: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style lang="sass" scoped>
    .loader
        position: absolute
        top: 0
        left: 0
        width: 100%
        height: 100%
        background: rgba(#fff, 0.3)
        display: flex
        justify-content: center
        align-items: center
        &.is-static
            position: fixed
            z-index: 1000
            background: rgba(#0B234B, 0.7)
            .loader__item
                border-color: #7695EE
        &__item
            width: 56px
            height: 56px
            border: 4px solid #0052ec
            border-radius: 50%
            position: relative
            animation: loader-scale 1s ease-out infinite
    @keyframes loader-scale
        0%
            transform: scale(0)
            opacity: 0
        50%
            opacity: 1
        100%
            transform: scale(1)
            opacity: 0
</style>